<template>
    <div class="card p-shadow-app">
        <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
        <Loading :active.sync="loading" :isFullPage="true"></Loading>

        <Dialog header="Histórico da Conversa" :visible.sync="displayModal" :modal="true" :style="{width: '50vw'}" :breakpoints="{'960px': '75vw', '640px': '95vw'}">
            <div class="chat-container p-p-2" v-if="selectedMessage">

                <div class="chat-message sent">
                    <div class="message-info">
                        <small>Enviado a {{ formatDate(selectedMessage.sent_at) }}</small>
                    </div>
                    <div class="message-bubble" v-html="selectedMessage.content"></div>
                </div>

                <div v-if="selectedMessage.response_content" class="chat-message received">
                    <div class="message-info">
                        <small>Respondeu a {{ formatDate(selectedMessage.responded_at) }}</small>
                    </div>
                    <div class="message-bubble">
                        <strong>Resposta:</strong> {{ selectedMessage.response_content }}
                    </div>
                </div>

                <div v-else-if="selectedMessage.status === 'pending'" class="p-text-center p-mt-3 text-muted">
                    <i class="pi pi-spin pi-spinner"></i> A aguardar resposta...
                </div>
                 <div v-else-if="selectedMessage.status === 'sent'" class="p-text-center p-mt-3 text-muted">
                    <i class="pi pi-check"></i> Mensagem informativa (sem resposta esperada).
                </div>

            </div>
            <template #footer>
                <Button label="Fechar" icon="pi pi-times" @click="displayModal = false" class="p-button-text"/>
            </template>
        </Dialog>

        <div class="card p-shadow-app">
            <header class="jumbotron">
                <div class="header-flex">
                    <h3 class="p-m-0">Histórico Notificações</h3>
                    <Button label="Actualizar" icon="pi pi-refresh" class="p-button-outlined p-button-sm" @click="refreshData" />
                </div>
            </header>
            <div class="p-mt-4">
                <DataTable
                  :value="list.data"
                  :filters.sync="filters"
                  filterDisplay="row"
                  :loading="loading"
                  :paginator="true"
                  :rows="20"
                  class="p-datatable-sm p-datatable-compact"
                  responsiveLayout="scroll"
                  :autoLayout="true"
                  stripedRows
                  :lazy="true"
                  :totalRecords="totalRecords"
                  @filter="loadLazyData"
                  @sort="loadLazyData"
                  @page="loadLazyData"
                >
                  <template #empty> Não existem registos. </template>

                  <Column field="provider_code" header="Tipo" sortable filterField="provider_code" :styles="{'width':'70px'}">
                    <template #body="slotProps">
                      {{ slotProps.data.provider_code }}
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <Dropdown v-model="filterModel.value"
                            :options="[{ label: 'email', value: 'email' }, { label: 'sms', value: 'sms' }]"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Filtrar por tipo"
                            @change="filterCallback()"
                            :showClear="true"
                            class="p-column-filter" />
                    </template>
                  </Column>

                  <Column field="model_id" header="Origem" sortable :styles="{'width':'100px'}">
                    <template #body="slotProps">
                       <span v-if="slotProps.data.model_id">
                        {{ formatModelType(slotProps.data.model_type) }} #{{ slotProps.data.model_id }}
                      </span>
                      <span v-if="slotProps.data.parent_model_id">
                        {{ formatModelType(slotProps.data.parent_model_type) }} #{{ slotProps.data.parent_model_id }}
                      </span>
                      <span v-else>-</span>
                    </template>
                  </Column>

                  <Column field="recipient" header="Destinatário" sortable filterField="recipient" :styles="{'width':'200px'}">
                    <template #body="slotProps">
                      {{ slotProps.data.recipient }}
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value"
                            placeholder="Filtrar por destinatário"
                            @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                  </Column>

                   <Column field="created_at" header="Data" sortable :styles="{'width':'100px'}">
                    <template #body="slotProps">
                      {{ formatDate(slotProps.data.created_at) }}
                    </template>
                  </Column>

                  <Column field="status" header="Estado" sortable :styles="{'width':'130px', 'text-align': 'center'}">
                    <template #body="slotProps">
                      <span :class="getStatusClass(slotProps.data.status)">
                        {{ translateStatus(slotProps.data.status) }}
                      </span>
                    </template>
                  </Column>

                  <Column field="subject" header="Assunto" sortable :styles="{'width':'180px'}">
                    <template #body="slotProps">
                      {{ slotProps.data.subject }}
                    </template>
                  </Column>

                  <Column field="content" header="Mensagem / Resposta">
                    <template #body="slotProps">
                        <div class="message-row">
                            <Button icon="pi pi-comments"
                                    class="p-button-rounded p-button-outlined p-button-sm p-mr-2"
                                    @click="openMessage(slotProps.data)"
                                    v-tooltip="'Ver conversa'" />

                            <div class="text-preview">
                                <div class="sent-preview" :title="stripHtml(slotProps.data.content)">
                                    <i class="pi pi-arrow-right p-text-secondary p-mr-1" style="font-size: 0.8rem"></i>
                                    {{ stripHtml(slotProps.data.content) }}
                                </div>
                                <div v-if="slotProps.data.response_content" class="response-preview">
                                    <i class="pi pi-arrow-left text-primary p-mr-1" style="font-size: 0.8rem"></i>
                                    <strong>{{ slotProps.data.response_content }}</strong>
                                </div>
                            </div>
                        </div>
                    </template>
                  </Column>

                  <Column field="error_message" header="Erro" :styles="{'width':'60px', 'text-align': 'center'}">
                    <template #body="slotProps">
                      <i v-if="slotProps.data.status === 'failed' && slotProps.data.error_message"
                         class="pi pi-exclamation-circle p-error"
                         style="font-size: 1.2rem"
                         v-tooltip.left="slotProps.data.error_message"></i>
                    </template>
                  </Column>

                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import notificationsService from '@/services/notifications.service';
import { FilterMatchMode } from "primevue/api";

export default {
  name: "NotificationLog",
  components: { Loading },
  data() {
    return {
      loading: false,
      list: [],
      totalRecords: 0,
      displayModal: false,
      selectedMessage: null,
      filters: {
        provider_code: { value: null, matchMode: FilterMatchMode.CONTAINS },
        recipient: { value: null, matchMode: FilterMatchMode.CONTAINS }
      }
    };
  },
  async created() {
    await this.loadLazyData({});
  },
  methods: {
    formatDate(date) {
        if (!date) return '-';
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        return `${day}/${month} ${hours}:${minutes}`;
    },
    formatModelType(type) {
        if (!type) return '';
        const parts = type.split('\\');
        return parts[parts.length - 1];
    },
    stripHtml(html) {
        if (!html) return '';
        let tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        let text = tmp.textContent || tmp.innerText || "";
        return text.replace(/(\r\n|\n|\r)/gm, " ").substring(0, 60) + (text.length > 60 ? '...' : '');
    },
    openMessage(data) {
        this.selectedMessage = data;
        this.displayModal = true;
    },
    translateStatus(status) {
        const map = {
            'pending': 'Pendente',
            'sent': 'Enviado',
            'replied': 'Respondido',
            'failed': 'Falhou'
        };
        return map[status] || status;
    },
    getStatusClass(status) {
        switch (status) {
            case 'failed': return 'status-badge status-error';
            case 'pending': return 'status-badge status-warning';
            case 'sent': return 'status-badge status-info';
            case 'replied': return 'status-badge status-success';
            default: return 'status-badge';
        }
    },
    buildQueryParams(page = 1) {
        const params = new URLSearchParams();
        params.append('page', page);
        for (const [key, filter] of Object.entries(this.filters)) {
            if (filter.value !== null && filter.value !== '') {
                params.append(`filters[${key}]`, filter.value);
            }
        }
        return params;
    },
    async loadLazyData(event) {
      this.loading = true;
      try {
        const page = event.page ? event.page + 1 : 1;
        const params = this.buildQueryParams(page);
        const response = await notificationsService.getLogs(params);
        if (response && response.data) {
          this.list = response.data;
          this.totalRecords = this.list.meta.total;
        }
      } catch (error) {
        console.error('Error loading logs:', error);
      } finally {
        this.loading = false;
      }
    },
    async refreshData() {
      await this.loadLazyData({});
    }
  }
};
</script>

<style scoped>
.p-datatable-compact .p-datatable-tbody > tr > td {
    padding: 0.5rem;
    font-size: 0.9rem;
}

.message-row {
    display: flex;
    align-items: center;
}
.text-preview {
    display: flex;
    flex-direction: column;
    font-size: 0.85rem;
}
.response-preview {
    color: #495057;
    margin-top: 2px;
}

.status-badge {
    padding: 0.25em 0.6em;
    border-radius: 4px;
    font-weight: 700;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
.status-success { background-color: #C8E6C9; color: #256029; }
.status-error { background-color: #FFCDD2; color: #C63737; }
.status-warning { background-color: #FEEDAF; color: #8A5340; }
.status-info { background-color: #B3E5FC; color: #23547B; }

.chat-container {
    background-color: #f4f6f9;
    border-radius: 6px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
}

.chat-message {
    max-width: 80%;
    margin-bottom: 1rem;
    position: relative;
}

.message-info {
    font-size: 0.75rem;
    color: #6c757d;
    margin-bottom: 2px;
}

.message-bubble {
    padding: 10px 15px;
    border-radius: 12px;
    font-size: 0.95rem;
    line-height: 1.4;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.chat-message.sent {
    align-self: flex-end;
    text-align: right;
}
.chat-message.sent .message-bubble {
    background-color: #E3F2FD;
    color: #212529;
    border-bottom-right-radius: 2px;
}

.chat-message.received {
    align-self: flex-start;
    text-align: left;
}
.chat-message.received .message-bubble {
    background-color: #ffffff;
    color: #212529;
    border-bottom-left-radius: 2px;
    border: 1px solid #dee2e6;
}

.p-error { color: #f44336; }
.text-muted { color: #6c757d; }
.text-primary { color: #2196F3; }

.header-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}
</style>